import { Trans } from "react-i18next";
import { ChatMessage } from "../models/chatbotModels";

export const ChatbotQuestion = ({ message, initials }: { message: ChatMessage, initials: string | undefined }) => {
  return (
    <div className="w-full rounded-lg p-4 flex">
      <div>
        <div className="w-16 h-16 rounded-full mx-auto flex items-center outline outline-1 outline-ua-pink justify-center bg-white text-black font-unleashed">
          {initials || "N/A"}
        </div>
      </div>
      <div className="pl-4">
        <p className="font-bold font-unleashed ml-2"><Trans>You</Trans></p>
        <p className="pl-1 ml-1">{message.message_text}</p>
      </div>
    </div>
  );
};